export default values => {
    const errors = {};
    const requiredFields = ["subject", "requestType", "body", "name", "email"];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "Required";
        }
    });
    return errors;
};
